import { DataOverview } from '@vwfs-bronson/bronson-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Contact, PersonalDetailsEditStatus } from 'cpes-common';
import { Notification, NotificationStatus } from '@cp-shared-19/frontend-ui';
import { NotificationForLastEditStatus } from './NotificationForLastEditStatus';
import { ContactList } from './ContactList';

export type ConsultViewProps = {
    contact: Contact;
    startEditing: () => void;
    lastEditStatus: PersonalDetailsEditStatus;
};

export const ConsultView: React.FC<ConsultViewProps> = ({ contact, startEditing, lastEditStatus }) => {
    const { t } = useTranslation('my-profile-contact-details');

    const isChangeAllowed = !!contact._links?.changeContactDetails; // CO-24455 temporary reverted, TODO - change it to false

    return (
        <DataOverview
            title={t('consultView.title')}
            buttonLabel={isChangeAllowed ? t('translation:editableSectionNav.start') : undefined}
            buttonProps={
                isChangeAllowed
                    ? {
                          onClick: startEditing,
                          onKeyDown: e => e.key === 'Enter' && startEditing(),
                          testId: 'editButton',
                          tabIndex: 0,
                      }
                    : undefined
            }
            titleLevel={2}
        >
            <Notification className="u-mb" status={NotificationStatus.info}>
                {t('consultView.info')}
            </Notification>
            <ContactList contact={contact} />
            <NotificationForLastEditStatus lastEditStatus={lastEditStatus} />
        </DataOverview>
    );
};
